<cdss-patient-detail-header
    [patientId]="patientId"
    (goBack)="goBack()"
    (patientLoaded)="onPatientLoaded($event)">
</cdss-patient-detail-header>

<div class="daily-panel position-relative">
    <overlay-spinner *ngIf="loading"></overlay-spinner>

    <!-- Header: title + day navigation (v2 — adherence donuts removed, UNIVAPLAT-2380) -->
    <div class="panel-header">
        <div class="panel-header__title-row">
            <h2 class="panel-title">Daily Summary</h2>
            <cdss-daily-patient-carer-toggle
                *ngIf="showPatientCarerToggle"
                active="patient"
                (select)="onPatientCarerToggleSelect($event)">
            </cdss-daily-patient-carer-toggle>
        </div>
        <div class="day-nav-metrics-row" *ngIf="date">
            <div class="day-nav-side">
                <button class="day-nav-arrow" (click)="navigateToPrevDay()" title="Previous day">
                    <i class="bi bi-chevron-left"></i>
                </button>
                <span class="day-nav-label">{{ date | date:'EEEE d MMM' }}</span>
                <button
                    class="day-nav-arrow"
                    (click)="navigateToNextDay()"
                    [disabled]="isToday"
                    [class.disabled]="isToday"
                    title="Next day">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- Main content: Daily check-in card / Chapter progress / Behaviour log -->
    <ng-container *ngIf="!loading && (summary || noData)">

        <!-- No statistics for this day: same layout, every section disabled (UNIVAPLAT-3259).
             The status line stays outside the inert block so assistive tech still announces it. -->
        <p class="no-data-status" role="status" *ngIf="noData">No data recorded for this day.</p>
        <div class="main-columns" [class.main-columns--disabled]="noData" [attr.inert]="noData ? '' : null">

            <!-- LEFT: Daily check-ins + Behaviour log (same column width) -->
            <div class="col-left">
                <div class="section-card mb-3">
                    <h3 class="section-title"><i class="bi bi-clipboard me-2"></i>Daily check-in</h3>
                    <cdss-daily-checkin-card
                        [checkins]="dailyCheckins"
                        variant="patient">
                    </cdss-daily-checkin-card>
                </div>

                <!-- Empty behaviours array = positive "None today", so always rendered -->
                <div class="section-card">
                    <cdss-daily-behaviour-panel
                        [behaviours]="behaviours"
                        variant="patient">
                    </cdss-daily-behaviour-panel>
                </div>
            </div>

            <!-- RIGHT: Chapter progress -->
            <div class="col-right">

                <!-- Weekly-scoped care-programme modules for the selected date's week (OQ-P2) —
                     same presentation component as the carer daily page (unified) -->
                <div class="section-card">
                    <h3 class="section-title"><i class="bi bi-book me-2"></i>Chapter progress</h3>
                    <cdss-weekly-chapter-list
                        [chapters]="chapterListItems"
                        [noDataText]="noData ? 'No chapter data for this day.' : null">
                    </cdss-weekly-chapter-list>
                </div>

            </div>

        </div>

    </ng-container>
</div>
